import { Dispatch, SetStateAction, useState } from 'react'
import MainPageWrapper from '../../global/components/MainPageWrapper'
import VansTable from '../table/VansTable'
import VansPageHeader from './page-header/VansPageHeader'
import VansTabChooser from './tab-chooser/VansTabChooser'
import MissionCapableReport from '../mission-capable/MissionCapableReport'
import { VAN_TAB_KEYS } from '../../global/constants/van'

export interface IRefreshCounterProps {
  refreshCounter: number
  setRefreshCounter: Dispatch<SetStateAction<number>>
}

interface IVansMainProps {
  tabType?: VAN_TAB_KEYS
}

function VansMain({ tabType = VAN_TAB_KEYS.vans }: IVansMainProps) {
  const [locationFilter, setLocationFilter] = useState('')
  const [refreshCounter, setRefreshCounter] = useState<number>(0)

  const showVansHeader = tabType === VAN_TAB_KEYS.vans

  return (
    <MainPageWrapper
      titleFields={
        showVansHeader ? (
          <VansPageHeader
            locationFilters={{ setLocationFilter, locationFilter }}
            refresh={{ refreshCounter, setRefreshCounter }}
          />
        ) : undefined
      }
    >
      <VansTabChooser />
      {tabType === VAN_TAB_KEYS.vans && (
        <VansTable
          locationFilters={{ locationFilter, setLocationFilter }}
          refresh={{ refreshCounter, setRefreshCounter }}
        />
      )}
      {tabType === VAN_TAB_KEYS.missionCapable && <MissionCapableReport />}
    </MainPageWrapper>
  )
}

export default VansMain
